export default "__VITE_ASSET__b18cff3e__"